let globalRevision = 0;
const galaxyRevisions = new Map<number, number>();

export function playerMapRevision(galaxyId: number): string {
  return `${globalRevision}:${galaxyRevisions.get(galaxyId) ?? 0}`;
}

export function markPlayerMapDirty(galaxyId: number): void {
  galaxyRevisions.set(galaxyId, (galaxyRevisions.get(galaxyId) ?? 0) + 1);
}

export function markAllPlayerMapsDirty(): void {
  globalRevision += 1;
  galaxyRevisions.clear();
}
